import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { Flex } from "../../..";
import { CalendarDay, CalendarEmptyDay } from "../CalendarDay";

var CalendarDaysWrapper = /*#__PURE__*/_styled(Flex, {
  target: "e5fotn50",
  label: "CalendarDaysWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1fg7h64",
  styles: "flex-wrap:wrap;margin-bottom:2px;margin-right:2px;"
} : {
  name: "1fg7h64",
  styles: "flex-wrap:wrap;margin-bottom:2px;margin-right:2px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RhdGVQaWNrZXIvY29tcG9uZW50cy9DYWxlbmRhckRheXMvQ2FsZW5kYXJEYXlzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVF3QyIsImZpbGUiOiIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9EYXRlUGlja2VyL2NvbXBvbmVudHMvQ2FsZW5kYXJEYXlzL0NhbGVuZGFyRGF5cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IGlzRXF1YWwgZnJvbSAnbG9kYXNoL2lzRXF1YWwnO1xuXG5pbXBvcnQgeyBGbGV4IH0gZnJvbSAnY29tcG9uZW50cyc7XG5pbXBvcnQgeyBDYWxlbmRhckRheSwgQ2FsZW5kYXJFbXB0eURheSB9IGZyb20gJy4uL0NhbGVuZGFyRGF5JztcblxuY29uc3QgQ2FsZW5kYXJEYXlzV3JhcHBlciA9IHN0eWxlZChGbGV4KWBcbiAgZmxleC13cmFwOiB3cmFwO1xuICBtYXJnaW4tYm90dG9tOiAycHg7XG4gIG1hcmdpbi1yaWdodDogMnB4O1xuYDtcblxuY29uc3QgZ2V0Q3VzdG9tRGF0ZVByb3BzID0gKFxuICBkaXNhYmxlZERhdGVzLFxuICBpbnRlcmFjdGl2ZURpc2FibGVkRGF0ZXMsXG4gIGlzSW5SYW5nZSxcbiAgZGF5LFxuKSA9PiB7XG4gIGNvbnN0IGlzRGlzYWJsZWQgPSBkaXNhYmxlZERhdGVzLnNvbWUoKGRpc2FibGVkRGF0ZSkgPT5cbiAgICBpc0VxdWFsKFN0cmluZyhkaXNhYmxlZERhdGUpLCBTdHJpbmcoZGF5LmRhdGUpKSxcbiAgKTtcblxuICBjb25zdCBwcm9wcyA9IHtcbiAgICBzZWxlY3RlZDogZGF5LnNlbGVjdGVkIHx8IChpbnRlcmFjdGl2ZURpc2FibGVkRGF0ZXMgJiYgZGF5LnNlbGVjdGFibGUpLFxuICAgIGhpZ2hsaWdodGVkOiBpc0luUmFuZ2UoZGF5LmRhdGUpLFxuICAgIHNlbGVjdGFibGU6IGRheS5zZWxlY3RhYmxlLFxuICB9O1xuXG4gIGlmIChpc0Rpc2FibGVkKSB7XG4gICAgcHJvcHMuc2VsZWN0YWJsZSA9IGZhbHNlO1xuICAgIHByb3BzLmhpZ2hsaWdodGVkID0gZmFsc2U7XG4gICAgcHJvcHMuZGlzYWJsZWQgPSAhaW50ZXJhY3RpdmVEaXNhYmxlZERhdGVzO1xuICB9XG5cbiAgcmV0dXJuIHByb3BzO1xufTtcblxuY29uc3QgQ2FsZW5kYXJEYXlzID0gKHtcbiAgd2Vla3MsXG4gIG1vbnRoLFxuICB5ZWFyLFxuICBnZXREYXRlUHJvcHMsXG4gIGRpc2FibGVkRGF0ZXMsXG4gIGludGVyYWN0aXZlRGlzYWJsZWREYXRlcyxcbiAgb25Nb3VzZUVudGVyT2ZEYXksXG4gIGlzSW5SYW5nZSxcbn0pID0+IChcbiAgPENhbGVuZGFyRGF5c1dyYXBwZXI+XG4gICAge3dlZWtzLm1hcCgod2VlaykgPT5cbiAgICAgIHdlZWsubWFwKChkYXksIGluZGV4KSA9PiB7XG4gICAgICAgIGlmICghZGF5KSB7XG4gICAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICAgIDxDYWxlbmRhckVtcHR5RGF5IGtleT17YCR7eWVhcn0ke21vbnRofSR7aW5kZXh9YH0gLz4gLy8gZXNsaW50LWRpc2FibGUtbGluZSByZWFjdC9uby1hcnJheS1pbmRleC1rZXlcbiAgICAgICAgICApO1xuICAgICAgICB9XG5cbiAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICA8Q2FsZW5kYXJEYXlcbiAgICAgICAgICAgIGtleT17YCR7eWVhcn0ke21vbnRofSR7aW5kZXh9YH0gLy8gZXNsaW50LWRpc2FibGUtbGluZSByZWFjdC9uby1hcnJheS1pbmRleC1rZXlcbiAgICAgICAgICAgIHsuLi5nZXREYXRlUHJvcHMoe1xuICAgICAgICAgICAgICBkYXRlT2JqOiBkYXksXG4gICAgICAgICAgICAgIG9uTW91c2VFbnRlcjogKCkgPT4gb25Nb3VzZUVudGVyT2ZEYXkoZGF5KSxcbiAgICAgICAgICAgIH0pfVxuICAgICAgICAgICAgey4uLmdldEN1c3RvbURhdGVQcm9wcyhcbiAgICAgICAgICAgICAgZGlzYWJsZWREYXRlcyxcbiAgICAgICAgICAgICAgaW50ZXJhY3RpdmVEaXNhYmxlZERhdGVzLFxuICAgICAgICAgICAgICBpc0luUmFuZ2UsXG4gICAgICAgICAgICAgIGRheSxcbiAgICAgICAgICAgICl9XG4gICAgICAgICAgPlxuICAgICAgICAgICAge2RheS5kYXRlLmdldERhdGUoKX1cbiAgICAgICAgICA8L0NhbGVuZGFyRGF5PlxuICAgICAgICApO1xuICAgICAgfSksXG4gICAgKX1cbiAgPC9DYWxlbmRhckRheXNXcmFwcGVyPlxuKTtcblxuQ2FsZW5kYXJEYXlzLmRlZmF1bHRQcm9wcyA9IHtcbiAgZGlzYWJsZWREYXRlczogW10sXG4gIGludGVyYWN0aXZlRGlzYWJsZWREYXRlczogZmFsc2UsXG4gIGlzSW5SYW5nZTogKCkgPT4ge30sXG4gIG9uTW91c2VFbnRlck9mRGF5OiAoKSA9PiB7fSxcbn07XG5cbkNhbGVuZGFyRGF5cy5wcm9wVHlwZXMgPSB7XG4gIG1vbnRoOiBQcm9wVHlwZXMubnVtYmVyLmlzUmVxdWlyZWQsXG4gIHllYXI6IFByb3BUeXBlcy5udW1iZXIuaXNSZXF1aXJlZCxcbiAgd2Vla3M6IFByb3BUeXBlcy5hcnJheU9mKFByb3BUeXBlcy5hcnJheSkuaXNSZXF1aXJlZCxcbiAgZ2V0RGF0ZVByb3BzOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICBkaXNhYmxlZERhdGVzOiBQcm9wVHlwZXMuYXJyYXlPZihQcm9wVHlwZXMuaW5zdGFuY2VPZihEYXRlKSksXG4gIGludGVyYWN0aXZlRGlzYWJsZWREYXRlczogUHJvcFR5cGVzLmJvb2wsXG4gIG9uTW91c2VFbnRlck9mRGF5OiBQcm9wVHlwZXMuZnVuYyxcbiAgaXNJblJhbmdlOiBQcm9wVHlwZXMuZnVuYyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENhbGVuZGFyRGF5cztcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var getCustomDateProps = function getCustomDateProps(disabledDates, interactiveDisabledDates, isInRange, day) {
  var isDisabled = disabledDates.some(function (disabledDate) {
    return isEqual(String(disabledDate), String(day.date));
  });
  var props = {
    selected: day.selected || interactiveDisabledDates && day.selectable,
    highlighted: isInRange(day.date),
    selectable: day.selectable
  };

  if (isDisabled) {
    props.selectable = false;
    props.highlighted = false;
    props.disabled = !interactiveDisabledDates;
  }

  return props;
};

var CalendarDays = function CalendarDays(_ref) {
  var weeks = _ref.weeks,
      month = _ref.month,
      year = _ref.year,
      getDateProps = _ref.getDateProps,
      disabledDates = _ref.disabledDates,
      interactiveDisabledDates = _ref.interactiveDisabledDates,
      onMouseEnterOfDay = _ref.onMouseEnterOfDay,
      isInRange = _ref.isInRange;
  return /*#__PURE__*/React.createElement(CalendarDaysWrapper, null, weeks.map(function (week) {
    return week.map(function (day, index) {
      if (!day) {
        return /*#__PURE__*/React.createElement(CalendarEmptyDay, {
          key: "".concat(year).concat(month).concat(index)
        }) // eslint-disable-line react/no-array-index-key
        ;
      }

      return /*#__PURE__*/React.createElement(CalendarDay, _extends({
        key: "".concat(year).concat(month).concat(index) // eslint-disable-line react/no-array-index-key

      }, getDateProps({
        dateObj: day,
        onMouseEnter: function onMouseEnter() {
          return onMouseEnterOfDay(day);
        }
      }), getCustomDateProps(disabledDates, interactiveDisabledDates, isInRange, day)), day.date.getDate());
    });
  }));
};

CalendarDays.defaultProps = {
  disabledDates: [],
  interactiveDisabledDates: false,
  isInRange: function isInRange() {},
  onMouseEnterOfDay: function onMouseEnterOfDay() {}
};
CalendarDays.propTypes = {
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  weeks: PropTypes.arrayOf(PropTypes.array).isRequired,
  getDateProps: PropTypes.func.isRequired,
  disabledDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  interactiveDisabledDates: PropTypes.bool,
  onMouseEnterOfDay: PropTypes.func,
  isInRange: PropTypes.func
};
export default CalendarDays;